import type { IOrderAttribute } from "../types";

export type FormTarget =
  | "contactDetails_before"
  | "contactDetails_after"
  | "shippingAddress_before"
  | "shippingAddress_after"
  | "billingaddress_before"
  | "billingaddress_after"
  | "buttonDelivery_before"
  | "buttonPlaceOrder_before";

type AdditionalParameters = {
  numeric?: boolean;
  placement: FormTarget;
};

export type OrderAttributeValues = { [key: string]: string };

export type OrderAttribute = Pick<
  IOrderAttribute,
  | "code"
  | "label"
  | "input_type"
  | "data_type"
  | "is_required"
  | "min_length"
  | "max_length"
  | "validate_regex"
  | "value"
  | "description"
  | "placeholder"
  | "sort_order"
> &
  AdditionalParameters;

export type OrderAttributeInfo = {
  attribute_code: FormTarget;
  value: string;
};
